<template>
  <component :is="layoutComponent" :field="field" :errors="errors">
    <template slot="field">
      <input
        :id="field.attribute"
        v-model="fieldValue"
        :dusk="field.attribute"
        type="url"
        :min="inputMin"
        :max="inputMax"
        :step="inputStep"
        :pattern="inputPattern"
        class="form-control"
        :class="errorClasses"
        :placeholder="inputPlaceholder"
        :readonly="inputReadonly"
        :disabled="inputDisabled"
      />
    </template>
  </component>
</template>

<script>
import { FieldMixin, setProp } from "stylemix-base";
import isEqual from "lodash-es/isEqual";

export default {
  name: "FormYoutubeField",

  mixins: [FieldMixin],

  props: {
    readonly: {},
    disabled: {},
    placeholder: {},
    step: {},
    min: {},
    max: {},
    pattern: {},
  },

  computed: {
    /**
     * Get the input type.
     */
    inputType() {
      return this.field.type || "text";
    },

    /**
     * Get the input placeholder.
     */
    inputPlaceholder() {
      return this.placeholder || this.field.placeholder;
    },

    /**
     * Get the input readonly state.
     */
    inputReadonly() {
      return this.readonly || this.field.readonly;
    },

    /**
     * Get the input disabled state.
     */
    inputDisabled() {
      return this.disabled || this.field.disabled;
    },

    /**
     * Get the input step amount.
     */
    inputStep() {
      return this.step || this.field.step;
    },

    /**
     * Get the input minimum amount.
     */
    inputMin() {
      return this.min || this.field.min;
    },

    /**
     * Get the input maximum amount.
     */
    inputMax() {
      return this.max || this.field.max;
    },

    /**
     * Get the pattern that should be used for the field
     */
    inputPattern() {
      return this.pattern || this.field.pattern;
    },
  },

  methods: {
    sanitizeValue(value) {
      return this.generateEmbeddedYoutubeLink(value);
    },

    /**
     * Generates embeddable youtube video link from original address copied form browser address
     *
     * @param {string} link Original youtube link, you can copy from browser address field
     * @return {string}
     */
    generateEmbeddedYoutubeLink(link) {
      const regExp =
        /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = link.match(regExp);

      if (match && match[2].length === 11) {
        return `https://www.youtube.com/embed/${match[2]}`;
      } else {
        return link;
      }
    },
  },
};
</script>
